import {
	configureStore, EnhancedStore, createAsyncThunk as createAsyncThunkBase, UnknownAction, ThunkDispatch,
	StoreEnhancer, Tuple,
	DevToolsEnhancerOptions
} from "@reduxjs/toolkit";
import { AppState } from "Data/Redux/Reducers";
import { Reducer } from "redux";
import { FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";
import { TypedUseSelectorHook, useSelector as reduxUseSelector, useDispatch as reduxUseDispatch } from "react-redux";

// type output from configure store, typed explicitly here as this has an impact on how our store.dispatch can be used
/* eslint-disable @typescript-eslint/no-explicit-any */
export let store: EnhancedStore<AppState, UnknownAction, Tuple<[StoreEnhancer<{
	dispatch: ThunkDispatch<AppState, undefined, UnknownAction>; }>, StoreEnhancer]>>;
/* eslint-enable @typescript-eslint/no-explicit-any */

export const buildStore = (reducer: Reducer, devTools: DevToolsEnhancerOptions, middleware) => {
	store = configureStore({
		reducer: reducer,
		devTools,
		middleware: (getDefaultMiddleware) => getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: [ FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER ]
			}
		})
			.prepend(
				middleware
			)
	});
};

export const createAsyncThunk = createAsyncThunkBase.withTypes<{ state: AppState }>();
export const useAppSelector: TypedUseSelectorHook<AppState> = reduxUseSelector;
export const useAppDispatch: () => typeof store.dispatch = reduxUseDispatch;
